import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-sync',
  templateUrl: './icon-sync.component.html',
  styleUrls: ['./icon-sync.component.scss']
})
export class IconSyncComponent implements OnInit {
  @Input() color: string = '#262628';
  @Input() size: number = 18;

  constructor() { }

  ngOnInit() {
  }

}
